import Icon from '@components/Icon/Icon';

import styles from '../Field.module.scss';

interface EmailContentProps {
  email: string;
  label?: string;
  size?: 'regular' | 'small' | 'extra-small';
  /** Will default to true. If false, no UI changes upon interaction. */
  interactive?: boolean;
}

const EmailContent: React.FC<React.PropsWithChildren<EmailContentProps>> = ({
  email,
  label,
  size,
  interactive = true,
}) => {
  return (
    <div className={styles['card-field']} data-size={size}>
      <div className={styles['card-item-icon-circle']} data-is-interactive={interactive} data-size={size}>
        <Icon type="email" className={styles['field-icon']} />
      </div>
      <div className={styles['field-data']}>
        <div className={styles['field-data-value']} data-type="email">
          {email}
        </div>
        {label && <div className={styles['field-data-label']}>{label}</div>}
        {!label && !email && <div className={styles['field-data-value-placeholder']}>Email</div>}
      </div>
    </div>
  );
};

export default EmailContent;
